import { configureStore } from '@reduxjs/toolkit';

import { authReducer } from '../auth/slices/authSlice';
import { profileReducer } from '../modules/settings/store/profileSlice';
import { workspaceEmailTemplatesReducer } from '../modules/settings/store/workspaceEmailTemplatesSlice';
import { workspaceSettingsReducer } from '../modules/settings/store/workspaceSettingsSlice';
import { workspaceUsersReducer } from '../modules/settings/store/workspaceUsersSlice';

import { globalNotificationReducer } from './slices/globalnotification';
import { globalProcessingReducer } from './slices/globalprocessing';
import { userReducer } from './slices/userSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    globalNotification: globalNotificationReducer,
    globalProcessing: globalProcessingReducer,
    settingsProfile: profileReducer,
    settingsWorkspaces: workspaceSettingsReducer,
    settingsWorkspaceUsers: workspaceUsersReducer,
    settingsWorkspaceEmailTemplates: workspaceEmailTemplatesReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
